import React from 'react'

import './TabsBar.scss'

const TabsBar = () => (
    <ul className="tabs">
        <li className="tab active">
            <span data-test-id="usecase-tab">Use Case</span>
        </li>
    </ul>
)

export default TabsBar
